import { render, staticRenderFns } from "./FttbInternetAccess.vue?vue&type=template&id=d0aa384a&"
import script from "./FttbInternetAccess.vue?vue&type=script&lang=js&"
export * from "./FttbInternetAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports